const tools = [
  { icon: 'ri-graduation-cap-line', title: 'Для одной компетенции', desc: 'может потребоваться тренинг.' },
  { icon: 'ri-tools-line', title: 'Для другой', desc: '— практика.' },
  { icon: 'ri-user-heart-line', title: 'Для третьей', desc: '— наставничество.' },
  { icon: 'ri-git-branch-line', title: 'Для четвёртой', desc: '— работа над реальным проектом.' },
];

export default function IPRAndTraining() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как связать ИПР с обучением
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-10">
          ИПР не должен превращаться в каталог тренингов
        </p>

        <p className="text-base md:text-lg text-gray-700 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
          Обучение — только один из инструментов развития, а не единственный способ развить компетенцию.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {tools.map((t, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-5 text-center hover:border-teal-200 transition-colors">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                <i className={`${t.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{t.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8">
          <h3 className="text-lg font-bold text-gray-900 text-center mb-6">Поэтому логика такая</h3>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {['Компетенция', 'Дефицит', 'Задача', 'Подходящий инструмент развития'].map((step, i, arr) => (
              <div key={step} className="flex items-center gap-3">
                <span className="bg-white border border-teal-200 text-teal-700 px-4 py-2 rounded-lg text-sm font-semibold">
                  {step}
                </span>
                {i < arr.length - 1 && <i className="ri-arrow-right-line text-teal-600"></i>}
              </div>
            ))}
          </div>
          <p className="text-center text-sm text-gray-500 mt-6">
            А не: <span className="font-semibold text-gray-700">«Сотрудник → отправить на тренинг»</span>
          </p>
        </div>
      </div>
    </section>
  );
}